/**
 * SEW Markaz COD Order Form (storefront script)
 * Copyright (c) 2026 Muhammad Mohib Kaleem. All rights reserved.
 *
 * Two modes share one modal:
 *  - product: roots rendered by snippets/sew-cod-form.liquid (the "Order Now" button on a product page)
 *  - cart:    one root rendered by snippets/sew-cod-cart.liquid; any Checkout button opens it with the whole cart
 */
(function () {
  if (window.__sewcodLoaded) { window.__sewcodInit && window.__sewcodInit(); return; }
  window.__sewcodLoaded = true;

  // Keep in sync with lib/config.js on the server (server is the source of truth).
  var DELIVERY = { karachi: 200, other: 350, karachiFreeAbove: 3000 };
  var BUNDLE = { minQty: 3, percent: 5 };
  var MAX_QTY = 10;
  var MAX_LINES = 10;
  var PHONE_RE = /^3[0-4]\d{8}$/;

  function money(n) {
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    return 'Rs. ' + (whole
      ? Math.round(n).toLocaleString('en-PK')
      : Number(n.toFixed(2)).toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }
  function normPhone(raw) {
    var d = String(raw || '').replace(/[^\d+]/g, '');
    if (d.charAt(0) === '+') d = d.slice(1);
    if (d.indexOf('0092') === 0) d = d.slice(4);
    else if (d.indexOf('92') === 0) d = d.slice(2);
    else if (d.charAt(0) === '0') d = d.slice(1);
    if (!PHONE_RE.test(d) || /^(\d)\1{6}$/.test(d.slice(3))) return null;
    return '+92' + d;
  }
  function delivery(discountedSubtotal, city) {
    if (!city) return null;
    if (city === 'Karachi') return discountedSubtotal >= DELIVERY.karachiFreeAbove ? 0 : DELIVERY.karachi;
    return DELIVERY.other;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function track(name, data, eventId) {
    try { if (window.fbq) window.fbq('track', name, data, eventId ? { eventID: eventId } : undefined); } catch (e) {}
    try { if (window.ttq) window.ttq.track(name === 'Purchase' ? 'CompletePayment' : name, data); } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(name === 'Purchase' ? 'sew_cod_order' : 'sew_cod_form_open', Object.assign({ event_id: eventId || null }, data));
      }
    } catch (e) {}
  }

  function setup(root, mode) {
    if (root.__sewcod) return;
    root.__sewcod = true;

    var isCart = mode === 'cart';
    var data = isCart ? null : JSON.parse(root.querySelector('[data-sewcod-product]').textContent);
    var endpoint = root.getAttribute('data-endpoint');
    var modal = root.querySelector('[data-sewcod-modal]');
    var form = root.querySelector('[data-sewcod-form]');
    var variantSel = root.querySelector('[data-sewcod-variant]');
    var qtyInput = root.querySelector('[data-sewcod-qty-input]');
    var thumb = root.querySelector('[data-sewcod-thumb]');
    var unitEl = root.querySelector('[data-sewcod-unit]');
    var linesEl = modal.querySelector('[data-sewcod-lines]');
    var subEl = modal.querySelector('[data-sewcod-subtotal]');
    var discRow = modal.querySelector('[data-sewcod-discount-row]');
    var discEl = modal.querySelector('[data-sewcod-discount]');
    var shipEl = modal.querySelector('[data-sewcod-shipping]');
    var totalEl = modal.querySelector('[data-sewcod-total]');
    var freeEl = modal.querySelector('[data-sewcod-free]');
    var bundleEl = modal.querySelector('[data-sewcod-bundle]');
    var cityHint = modal.querySelector('[data-sewcod-city-hint]');
    var formErr = modal.querySelector('[data-sewcod-form-error]');
    var submitBtn = modal.querySelector('[data-sewcod-submit]');
    var submitLabel = modal.querySelector('[data-sewcod-submit-label]');
    var lastFocus = null;
    var busy = false;
    var ordered = false;
    var state = { variantId: data && data.currentVariant, qty: 1, cartLines: [] };
    // Extra items the shopper adds from the "Add more items" panel (product and cart mode).
    var extras = [];

    // Move the overlay to <body> so theme containers (transform/overflow) cannot clip it.
    document.body.appendChild(modal);

    if (variantSel) {
      data.variants.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.id;
        o.textContent = v.title + (v.available ? '' : ' (Sold out)');
        o.disabled = !v.available;
        variantSel.appendChild(o);
      });
      variantSel.addEventListener('change', function () { state.variantId = Number(variantSel.value); render(); });
    }

    function variant() {
      return data.variants.find(function (v) { return v.id === Number(state.variantId); }) || data.variants[0];
    }
    // Look in this product section first so quick-add forms elsewhere on the page can never win.
    function scope() { return root.closest('section') || document; }
    function pageVariantId() {
      var input = scope().querySelector('form[data-type="add-to-cart-form"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = input && Number(input.value);
      return data.variants.some(function (v) { return v.id === id && v.available; }) ? id : null;
    }
    function pageQty() {
      var q = scope().querySelector('input.quantity__input') || document.querySelector('form[action*="/cart/add"] [name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return n >= 1 ? Math.min(MAX_QTY, n) : 1;
    }

    // The order lines the shopper is buying right now: [{ id, qty, unit (rupees) }].
    function lines() {
      var more = extras.map(function (x) { return { id: x.id, qty: x.qty, unit: x.unit }; });
      if (isCart) return state.cartLines.concat(more);
      return [{ id: Number(state.variantId), qty: state.qty, unit: variant().price / 100 }].concat(more);
    }
    function totals(city) {
      var ls = lines();
      var qty = 0, paisa = 0;
      ls.forEach(function (l) { qty += l.qty; paisa += Math.round(l.unit * 100) * l.qty; });
      var sub = paisa / 100;
      var disc = qty >= BUNDLE.minQty ? Math.round(paisa * BUNDLE.percent / 100) / 100 : 0;
      var ship = delivery(sub - disc, city);
      return { qty: qty, sub: sub, disc: disc, ship: ship, total: sub - disc + (ship || 0) };
    }


    // ---- "Add more items" panel (product and cart mode) ----
    // Products come from the store's public JSON (collections and /products.json); prices are
    // re-checked on the server, so the browser never decides what anything costs.
    var addMore = (function () {
      var wrap = modal.querySelector('[data-sewcod-add]');
      if (!wrap) return null;
      var listEl = modal.querySelector('[data-sewcod-extras]');
      var toggle = wrap.querySelector('[data-sewcod-add-toggle]');
      var toggleHint = wrap.querySelector('[data-sewcod-add-hint]');
      var panel = wrap.querySelector('[data-sewcod-add-panel]');
      var search = wrap.querySelector('[data-sewcod-add-search]');
      var chips = wrap.querySelectorAll('[data-sewcod-add-cat]');
      var results = wrap.querySelector('[data-sewcod-add-results]');
      var cache = {};
      var all = null;
      var current = [];
      var activeCat = chips.length ? chips[0].getAttribute('data-sewcod-add-cat') : '';
      var started = false;
      var timer = null;

      function thumbUrl(src) {
        if (!src) return '';
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=96';
      }
      function toItem(p) {
        var vs = (p.variants || []).filter(function (v) { return v.available; }).map(function (v) {
          return { id: v.id, title: v.title, price: parseFloat(v.price) || 0, compare: parseFloat(v.compare_at_price) || 0 };
        });
        return { pid: p.id, title: p.title, image: p.images && p.images[0] ? thumbUrl(p.images[0].src) : '', variants: vs };
      }
      function usable(items) {
        return items.filter(function (it) { return it.variants.length && !(data && it.pid === data.id); });
      }
      function getJSON(url) {
        return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      }
      function loadCat(handle) {
        if (cache[handle]) return Promise.resolve(cache[handle]);
        return getJSON('/collections/' + handle + '/products.json?limit=50').then(function (d) {
          cache[handle] = usable((d.products || []).map(toItem));
          return cache[handle];
        });
      }
      function loadAll() {
        if (all) return Promise.resolve(all);
        return getJSON('/products.json?limit=250').then(function (d) {
          all = usable((d.products || []).map(toItem));
          return all;
        });
      }
      function message(text) {
        results.innerHTML = '<p class="sewcod__add-empty">' + esc(text) + '</p>';
      }
      function showList(items) {
        current = items;
        if (!items.length) { message('No products found. Try another word or category.'); return; }
        results.innerHTML = items.map(function (it) {
          var v = it.variants[0];
          var select = it.variants.length > 1
            ? '<select class="sewcod__add-variant" data-sewcod-add-variant="' + it.pid + '" aria-label="Option for ' + esc(it.title) + '">' +
              it.variants.map(function (x) { return '<option value="' + x.id + '">' + esc(x.title) + ' · ' + esc(money(x.price)) + '</option>'; }).join('') +
              '</select>'
            : '';
          return '<div class="sewcod__add-row">' +
            (it.image ? '<img class="sewcod__add-thumb" src="' + esc(it.image) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="sewcod__add-thumb"></span>') +
            '<div class="sewcod__add-info"><div class="sewcod__add-title">' + esc(it.title) + '</div>' +
            '<div class="sewcod__add-price">' + money(v.price) + (v.compare > v.price ? ' <s>' + money(v.compare) + '</s>' : '') + '</div>' + select + '</div>' +
            '<button type="button" class="sewcod__add-btn" data-sewcod-add-btn="' + it.pid + '">Add</button></div>';
        }).join('');
      }
      function showCat(handle) {
        activeCat = handle;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(!search.value.trim() && c.getAttribute('data-sewcod-add-cat') === handle)); });
        message('Loading products...');
        loadCat(handle).then(showList).catch(function () { message('Could not load products. Please check your internet and try again.'); });
      }
      function runSearch() {
        var q = search.value.trim().toLowerCase();
        if (!q) { showCat(activeCat); return; }
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        message('Searching...');
        loadAll().then(function (items) {
          if (search.value.trim().toLowerCase() !== q) return;
          showList(items.filter(function (it) { return it.title.toLowerCase().indexOf(q) !== -1; }).slice(0, 30));
        }).catch(function () { message('Could not search right now. Please try again.'); });
      }
      function add(pid) {
        var it = current.filter(function (x) { return String(x.pid) === String(pid); })[0];
        if (!it) return;
        var sel = results.querySelector('[data-sewcod-add-variant="' + pid + '"]');
        var vid = sel ? Number(sel.value) : it.variants[0].id;
        var v = it.variants.filter(function (x) { return x.id === vid; })[0] || it.variants[0];
        var mainId = isCart ? null : Number(state.variantId);
        var inCart = isCart ? state.cartLines.filter(function (l) { return Number(l.id) === v.id; })[0] : null;
        var existing = extras.filter(function (x) { return x.id === v.id; })[0];
        if (v.id === mainId) { state.qty = Math.min(MAX_QTY, state.qty + 1); }
        else if (inCart) { inCart.qty = Math.min(MAX_QTY, inCart.qty + 1); }
        else if (existing) { existing.qty = Math.min(MAX_QTY, existing.qty + 1); }
        else {
          if (lines().length >= MAX_LINES) { formErr.textContent = 'You can order up to ' + MAX_LINES + ' different items in one order.'; return; }
          extras.push({ id: v.id, productId: it.pid, qty: 1, unit: v.price, title: it.title,
            variantTitle: v.title && v.title !== 'Default Title' ? v.title : '', image: it.image });
        }
        formErr.textContent = '';
        render();
        var btn = results.querySelector('[data-sewcod-add-btn="' + pid + '"]');
        if (btn) { btn.textContent = 'Added'; setTimeout(function () { if (btn.isConnected) btn.textContent = 'Add'; }, 1200); }
      }

      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
        if (open) start();
      });
      chips.forEach(function (c) {
        c.addEventListener('click', function () { search.value = ''; showCat(c.getAttribute('data-sewcod-add-cat')); });
      });
      search.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(runSearch, 250); });
      search.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
      results.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sewcod-add-btn]');
        if (b) add(b.getAttribute('data-sewcod-add-btn'));
      });
      listEl.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        var id = Number(b.getAttribute('data-id'));
        var x = extras.filter(function (y) { return y.id === id; })[0];
        if (!x) return;
        if (b.hasAttribute('data-remove')) extras = extras.filter(function (y) { return y.id !== id; });
        else x.qty = Math.min(MAX_QTY, Math.max(1, x.qty + Number(b.getAttribute('data-step'))));
        render();
      });

      function start() {
        if (started || panel.hidden) return;
        started = true;
        if (activeCat) showCat(activeCat);
      }
      function renderAdd(t) {
        listEl.innerHTML = extras.map(function (x) {
          return '<div class="sewcod__extra">' +
            (x.image ? '<img class="sewcod__add-thumb" src="' + esc(x.image) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="sewcod__add-thumb"></span>') +
            '<div class="sewcod__add-info"><div class="sewcod__add-title">' + esc(x.title) + '</div>' +
            '<div class="sewcod__add-price">' + (x.variantTitle ? esc(x.variantTitle) + ' · ' : '') + money(x.unit) + '</div>' +
            '<button type="button" class="sewcod__extra-remove" data-remove data-id="' + x.id + '">Remove</button></div>' +
            '<div class="sewcod__extra-qty"><button type="button" data-step="-1" data-id="' + x.id + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + x.qty + '</span><button type="button" data-step="1" data-id="' + x.id + '" aria-label="Increase quantity">+</button></div></div>';
        }).join('');
        listEl.hidden = !extras.length;
        var more = BUNDLE.minQty - t.qty;
        toggleHint.textContent = more > 0 ? more + ' more for ' + BUNDLE.percent + '% off' : BUNDLE.percent + '% off applied';
      }
      return { render: renderAdd, start: start };
    })();

    function render() {
      var city = form.elements.city.value;
      var t = totals(city);
      if (!isCart) {
        var v = variant();
        if (thumb && v.image) thumb.src = v.image;
        unitEl.innerHTML = money(v.price / 100) + (v.compareAt > v.price ? ' <s>' + money(v.compareAt / 100) + '</s>' : '');
        qtyInput.value = state.qty;
      }
      subEl.textContent = money(t.sub);
      discRow.hidden = t.disc <= 0;
      discEl.textContent = t.disc > 0 ? '- ' + money(t.disc) : '';
      shipEl.textContent = t.ship === null ? 'Select city' : t.ship === 0 ? 'Free' : money(t.ship);
      totalEl.textContent = money(t.total);

      var afterDisc = t.sub - t.disc;
      if (city === 'Karachi' && afterDisc < DELIVERY.karachiFreeAbove) {
        freeEl.hidden = false;
        freeEl.textContent = 'Add ' + money(DELIVERY.karachiFreeAbove - afterDisc) + ' more for free delivery in Karachi.';
      } else {
        freeEl.hidden = true;
      }
      if (t.qty >= BUNDLE.minQty) {
        bundleEl.hidden = false;
        bundleEl.textContent = BUNDLE.percent + '% multi-item discount applied.';
      } else if (t.qty >= 1) {
        var more = BUNDLE.minQty - t.qty;
        bundleEl.hidden = false;
        bundleEl.textContent = (isCart ? 'Add ' + more + ' more item' + (more > 1 ? 's' : '') + ' to your cart' : 'Add ' + more + ' more item' + (more > 1 ? 's' : '')) + ' and get ' + BUNDLE.percent + '% off.';
      } else {
        bundleEl.hidden = true;
      }
      cityHint.textContent = city === 'Karachi' ? 'Open parcel (check before payment) available in Karachi.' : '';
      if (addMore) addMore.render(t);

      if (isCart && linesEl) {
        linesEl.innerHTML = state.cartItems.map(function (it) {
          return '<div class="sewcod__line">' +
            (it.image ? '<img class="sewcod__thumb" src="' + esc(it.image) + '" alt="" width="48" height="48" loading="lazy">' : '') +
            '<div class="sewcod__line-info"><div class="sewcod__line-title">' + esc(it.title) + '</div>' +
            '<div class="sewcod__line-meta">' + (it.variantTitle ? esc(it.variantTitle) + ' · ' : '') + 'Qty ' + it.qty + '</div></div>' +
            '<div class="sewcod__line-total">' + money(it.unit * it.qty) + '</div></div>';
        }).join('');
      }
    }

    function showStep(step) {
      modal.querySelectorAll('[data-sewcod-step]').forEach(function (el) {
        el.hidden = el.getAttribute('data-sewcod-step') !== step;
      });
    }
    function reveal() {
      document.body.appendChild(modal); // stay above any popup that was added later
      modal.hidden = false;
      document.body.classList.add('sewcod-lock');
      setTimeout(function () { form.elements.name.focus(); }, 60);
    }

    function open() {
      lastFocus = document.activeElement;
      ordered = false;
      formErr.textContent = '';
      state.variantId = pageVariantId() || state.variantId;
      state.qty = pageQty();
      if (variantSel) variantSel.value = state.variantId;
      showStep('form');
      render();
      reveal();
      var v = variant();
      track('InitiateCheckout', { content_ids: [String(v.id)], content_type: 'product_variant', value: (v.price / 100) * state.qty, currency: 'PKR', num_items: state.qty });
      if (addMore) addMore.start();
    }

    // Cart mode: read the live cart each time, so the form always matches what the shopper sees.
    function openCart() {
      lastFocus = document.activeElement;
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) return;
          state.cartItems = cart.items.map(function (it) {
            return {
              id: it.variant_id,
              productId: it.product_id,
              qty: it.quantity,
              unit: it.original_price / 100,
              title: it.product_title,
              variantTitle: it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '',
              image: it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_96x96$1$2') : ''
            };
          });
          state.cartLines = state.cartItems;
          extras = [];
          state.cartNote = cart.note || '';
          ordered = false;
          formErr.textContent = '';
          showStep('form');
          render();
          reveal();
          var tt = totals('');
          if (addMore) addMore.start();
          track('InitiateCheckout', { content_ids: state.cartItems.map(function (i) { return String(i.productId); }), content_type: 'product', value: tt.sub - tt.disc, currency: 'PKR', num_items: tt.qty });
        })
        .catch(function () { window.location.href = '/checkout'; });
    }
    root.__sewcodOpen = openCart;

    function close() {
      if (busy) return;
      modal.hidden = true;
      document.body.classList.remove('sewcod-lock');
      // A placed cart order empties the cart, so refresh the page to clear the drawer and cart icon.
      if (isCart && ordered) { window.location.reload(); return; }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function fieldError(name, msg) {
      var el = form.querySelector('[data-error-for="' + name + '"]');
      if (el) el.textContent = msg || '';
      var field = form.elements[name] && form.elements[name].closest('.sewcod__field');
      if (field) field.classList.toggle('is-invalid', !!msg);
    }
    function clearErrors() {
      ['name', 'phone', 'city', 'address', 'email'].forEach(function (n) { fieldError(n, ''); });
      formErr.textContent = '';
    }
    function validate() {
      clearErrors();
      var ok = true, first = null;
      var f = form.elements;
      var name = f.name.value.trim();
      if (name.length < 3 || /\d/.test(name) || name.split(/\s+/).filter(Boolean).length < 2) { fieldError('name', 'Please enter your first and last name, e.g. Ahmed Khan.'); ok = false; first = first || f.name; }
      if (!normPhone(f.phone.value)) { fieldError('phone', 'Please enter a valid mobile number, e.g. 03XX XXXXXXX.'); ok = false; first = first || f.phone; }
      if (!f.city.value) { fieldError('city', 'Please select your city.'); ok = false; first = first || f.city; }
      var addr = f.address.value.trim();
      if (addr.length < 12 || !/\s/.test(addr)) { fieldError('address', 'Please enter your complete address (house, street, area).'); ok = false; first = first || f.address; }
      var email = f.email.value.trim();
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { fieldError('email', 'Please enter a valid email address, or leave it blank.'); ok = false; first = first || f.email; }
      if (isCart || extras.length) {
        var all = lines();
        var tooMany = all.some(function (l) { return l.qty > MAX_QTY; });
        if (tooMany || all.length > MAX_LINES) {
          formErr.textContent = 'Please keep each item to ' + MAX_QTY + ' units and the cart to ' + MAX_LINES + ' different items, or contact us on WhatsApp for a bulk order.';
          ok = false;
        }
      }
      if (first) first.focus();
      return ok;
    }

    function setBusy(on) {
      busy = on;
      submitBtn.disabled = on;
      submitLabel.innerHTML = on ? '<span class="sewcod__spinner"></span>Placing your order...' : 'Place Order';
    }

    var openBtn = root.querySelector('[data-sewcod-open]');
    if (openBtn) openBtn.addEventListener('click', open);
    modal.querySelectorAll('[data-sewcod-close]').forEach(function (b) { b.addEventListener('click', close); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    // Escape closes the form; Tab and Shift+Tab stay inside it while it is open.
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
      if (e.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(
        modal.querySelectorAll('button, input, select, textarea, summary, a[href]'),
        function (el) { return !el.disabled && el.tabIndex !== -1 && el.offsetParent !== null; }
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }, true);

    modal.querySelectorAll('[data-sewcod-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.qty = Math.min(MAX_QTY, Math.max(1, state.qty + Number(b.getAttribute('data-sewcod-qty'))));
        render();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      var n = parseInt(qtyInput.value, 10);
      state.qty = n >= 1 ? Math.min(MAX_QTY, n) : 1;
      render();
    });
    form.elements.city.addEventListener('change', function () { fieldError('city', ''); render(); });
    ['name', 'phone', 'address', 'email'].forEach(function (n) {
      form.elements[n].addEventListener('input', function () { fieldError(n, ''); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy || !validate()) return;
      setBusy(true);
      var f = form.elements;
      var notes = f.notes.value.trim();
      if (isCart && state.cartNote) notes = (notes ? notes + ' | ' : '') + 'Cart note: ' + state.cartNote;
      var payload = {
        name: f.name.value.trim(),
        phone: f.phone.value.trim(),
        city: f.city.value,
        address: f.address.value.trim(),
        email: f.email.value.trim(),
        notes: notes.slice(0, 300),
        website: f.website.value,
        sourceUrl: isCart ? window.location.origin + '/cart' : data.url,
        items: lines().map(function (l) { return { variantId: Number(l.id), quantity: l.qty }; })
      };
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (res) {
          setBusy(false);
          if (!res || !res.ok) {
            if (res && res.field && form.elements[res.field]) { fieldError(res.field, res.error); form.elements[res.field].focus(); }
            else formErr.textContent = (res && res.error) || 'We could not place your order right now. Please try again, or contact us on WhatsApp.';
            return;
          }
          ordered = true;
          modal.querySelector('[data-sewcod-order-name]').textContent = res.orderName;
          modal.querySelector('[data-sewcod-order-total]').textContent = money(res.total);
          // Delivery windows match the product page trust block (confirmed Sep 2026).
          modal.querySelector('[data-sewcod-success-note]').textContent = 'We will send a confirmation message to your WhatsApp number shortly. Please reply YES to confirm your order, and we will dispatch it right away. Estimated delivery: ' + (payload.city === 'Karachi' ? '5–6' : '7–10') + ' working days after confirmation.';
          showStep('success');
          form.reset();
          extras = [];
          if (addMore) addMore.render(totals(''));
          if (isCart) { try { fetch('/cart/clear.js', { method: 'POST' }); } catch (err) {} }
          track('Purchase', {
            value: res.total,
            currency: 'PKR',
            content_type: 'product',
            content_ids: res.items.map(function (i) { return String(i.productId); }),
            contents: res.items.map(function (i) { return { id: String(i.productId), quantity: i.quantity, item_price: i.price }; }),
            num_items: res.items.reduce(function (s, i) { return s + i.quantity; }, 0),
            order_id: res.orderName
          }, res.orderName);
        })
        .catch(function () {
          setBusy(false);
          formErr.textContent = 'Connection problem. Please check your internet and try again.';
        });
    });
  }

  window.__sewcodInit = function () {
    document.querySelectorAll('[data-sewcod]').forEach(function (r) { setup(r, 'product'); });
    document.querySelectorAll('[data-sewcod-cart]').forEach(function (r) { setup(r, 'cart'); });
  };

  // Every Checkout button in the theme (cart page, cart drawer, notification) opens the COD form instead.
  var CHECKOUT_SEL = 'button[name="checkout"], input[name="checkout"], #checkout, #CartDrawer-Checkout, a[href="/checkout"], a[href^="/checkout?"]';
  function cartRoot() {
    var r = document.querySelector('[data-sewcod-cart]');
    return r && r.__sewcodOpen ? r : null;
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest(CHECKOUT_SEL) : null;
    var r = t && cartRoot();
    if (!r) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    r.__sewcodOpen();
  }, true);
  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    var r = s && s.name === 'checkout' && cartRoot();
    if (!r) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    r.__sewcodOpen();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.__sewcodInit);
  else window.__sewcodInit();
  // Theme editor re-renders sections
  document.addEventListener('shopify:section:load', window.__sewcodInit);
})();
